<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>堆雪球管理</el-breadcrumb-item>
      <el-breadcrumb-item>令牌管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 账号管理卡片 -->
    <el-card class="box-card" style="margin-bottom: 20px;">
      <div slot="header" class="flexContainer">
        <span class="cardHeader">堆雪球账号管理</span>
        <el-button style="float:right;" type="primary" size="normal" @click="getAccount">获取当前账号</el-button>
      </div>

      <el-form :model="accountForm" :rules="accountRules" ref="accountForm" label-width="120px" size="normal">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="堆雪球账号：" prop="account">
              <el-input v-model="accountForm.account" placeholder="请输入堆雪球账号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="堆雪球密码：" prop="password">
              <el-input v-model="accountForm.password" type="password" placeholder="请输入堆雪球密码" clearable show-password></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item>
          <el-button type="primary" @click="setAccount" :loading="accountLoading">保存账号</el-button>
          <el-button type="success" @click="loginDuixueqiu" :loading="loginLoading">堆雪球登录</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 令牌管理卡片 -->
    <el-card class="box-card">
      <div slot="header" class="flexContainer">
        <span class="cardHeader">访问令牌管理</span>
        <el-button style="float:right;" type="primary" size="normal" @click="getToken">获取当前令牌</el-button>
      </div>

      <el-form :model="tokenForm" :rules="tokenRules" ref="tokenForm" label-width="120px" size="normal">
        <el-form-item label="访问令牌：" prop="access_token">
          <el-input v-model="tokenForm.access_token" type="textarea" :rows="3" placeholder="请输入访问令牌" clearable></el-input>
        </el-form-item>
        <el-form-item label="刷新令牌：" prop="refresh_token">
          <el-input v-model="tokenForm.refresh_token" type="textarea" :rows="3" placeholder="请输入刷新令牌" clearable></el-input>
        </el-form-item>
        <el-form-item label="过期时间：" prop="expires_time">
          <el-date-picker
            v-model="tokenForm.expires_time"
            type="datetime"
            placeholder="选择过期时间"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="timestamp"
            style="width: 100%;">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="setToken" :loading="tokenLoading">保存令牌</el-button>
          <el-button type="warning" @click="refreshToken" :loading="refreshLoading">刷新令牌</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 令牌状态显示 -->
    <el-card class="box-card" style="margin-top: 20px;" v-if="tokenStatus.access_token">
      <div slot="header" class="flexContainer">
        <span class="cardHeader">当前令牌状态</span>
      </div>

      <el-descriptions :column="1" border>
        <el-descriptions-item label="访问令牌">
          <el-tag type="success" v-if="tokenStatus.access_token">已配置</el-tag>
          <el-tag type="danger" v-else>未配置</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="刷新令牌">
          <el-tag type="success" v-if="tokenStatus.refresh_token">已配置</el-tag>
          <el-tag type="danger" v-else>未配置</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="过期时间">
          <span v-if="tokenStatus.expires_time">{{ $getDateTime(tokenStatus.expires_time) }}</span>
          <el-tag type="danger" v-else>未设置</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="令牌状态">
          <el-tag :type="isTokenExpired ? 'danger' : 'success'">
            {{ isTokenExpired ? '已过期' : '有效' }}
          </el-tag>
        </el-descriptions-item>
      </el-descriptions>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'DuixueqiuToken',
  data () {
    return {
      // 账号表单
      accountForm: {
        account: '',
        password: ''
      },
      // 账号验证规则
      accountRules: {
        account: [
          { required: true, message: '请输入堆雪球账号', trigger: 'blur' },
          { min: 2, max: 15, message: '账号长度在 2 到 15 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入堆雪球密码', trigger: 'blur' },
          { min: 5, max: 15, message: '密码长度在 5 到 15 个字符', trigger: 'blur' }
        ]
      },
      // 令牌表单
      tokenForm: {
        access_token: '',
        refresh_token: '',
        expires_time: null
      },
      // 令牌验证规则
      tokenRules: {
        access_token: [
          { required: true, message: '请输入访问令牌', trigger: 'blur' }
        ],
        refresh_token: [
          { required: true, message: '请输入刷新令牌', trigger: 'blur' }
        ],
        expires_time: [
          { required: true, message: '请选择过期时间', trigger: 'change' }
        ]
      },
      // 令牌状态
      tokenStatus: {
        access_token: '',
        refresh_token: '',
        expires_time: null
      },
      // 加载状态
      accountLoading: false,
      loginLoading: false,
      tokenLoading: false,
      refreshLoading: false
    }
  },
  computed: {
    // 判断令牌是否过期
    isTokenExpired () {
      if (!this.tokenStatus.expires_time) return true
      return Date.now() > this.tokenStatus.expires_time
    }
  },
  created () {
    // 页面加载时获取当前账号和令牌信息
    this.getAccount()
    this.getToken()
  },
  methods: {
    // 获取堆雪球账号
    async getAccount () {
      try {
        const { data: res } = await this.$http.get('duixueqiu/getAccount')
        if (res.meta.status === 200) {
          this.accountForm.account = res.data.account || ''
          this.accountForm.password = res.data.password || ''
          this.$message.success('获取账号信息成功')
        } else {
          this.$message.error(res.message || '获取账号信息失败')
        }
      } catch (error) {
        this.$message.error('获取账号信息失败：' + error.message)
      }
    },

    // 设置堆雪球账号
    async setAccount () {
      this.$refs.accountForm.validate(async (valid) => {
        if (!valid) return

        this.accountLoading = true
        try {
          const { data: res } = await this.$http.post('duixueqiu/setAccount', {
            account: this.accountForm.account,
            password: this.accountForm.password
          })

          if (res.meta.status === 200) {
            this.$message.success('保存账号成功')
          } else {
            this.$message.error(res.message || '保存账号失败')
          }
        } catch (error) {
          this.$message.error('保存账号失败：' + error.message)
        } finally {
          this.accountLoading = false
        }
      })
    },

    // 堆雪球登录
    async loginDuixueqiu () {
      this.$refs.accountForm.validate(async (valid) => {
        if (!valid) return

        this.loginLoading = true
        try {
          const { data: res } = await this.$http.post('duixueqiu/login', {
            account: this.accountForm.account,
            password: this.accountForm.password
          })

          if (res.meta.status === 200) {
            this.$message.success('登录成功')
            // 登录成功后更新令牌信息
            this.tokenStatus = {
              access_token: res.data.access_token,
              refresh_token: res.data.refresh_token,
              expires_time: res.data.expires_time
            }
            // 同时更新表单中的令牌信息
            this.tokenForm = { ...this.tokenStatus }
          } else {
            this.$message.error(res.message || '登录失败')
          }
        } catch (error) {
          this.$message.error('登录失败：' + error.message)
        } finally {
          this.loginLoading = false
        }
      })
    },

    // 获取访问令牌
    async getToken () {
      try {
        const { data: res } = await this.$http.get('duixueqiu/getToken')
        if (res.meta.status === 200) {
          this.tokenStatus = {
            access_token: res.data.access_token || '',
            refresh_token: res.data.refresh_token || '',
            expires_time: res.data.expires_time || null
          }
          this.tokenForm = { ...this.tokenStatus }
          this.$message.success('获取令牌信息成功')
        } else {
          this.$message.error(res.message || '获取令牌信息失败')
        }
      } catch (error) {
        this.$message.error('获取令牌信息失败：' + error.message)
      }
    },

    // 设置访问令牌
    async setToken () {
      this.$refs.tokenForm.validate(async (valid) => {
        if (!valid) return

        this.tokenLoading = true
        try {
          const { data: res } = await this.$http.post('duixueqiu/setToken', {
            access_token: this.tokenForm.access_token,
            refresh_token: this.tokenForm.refresh_token,
            expires_time: this.tokenForm.expires_time
          })

          if (res.meta.status === 200) {
            this.$message.success('保存令牌成功')
            // 更新令牌状态
            this.tokenStatus = { ...this.tokenForm }
          } else {
            this.$message.error(res.message || '保存令牌失败')
          }
        } catch (error) {
          this.$message.error('保存令牌失败：' + error.message)
        } finally {
          this.tokenLoading = false
        }
      })
    },

    // 刷新访问令牌
    async refreshToken () {
      if (!this.tokenStatus.refresh_token) {
        this.$message.error('请先设置刷新令牌')
        return
      }

      this.refreshLoading = true
      try {
        const { data: res } = await this.$http.post('duixueqiu/refreshToken', {
          refresh_token: this.tokenStatus.refresh_token
        })

        if (res.meta.status === 200) {
          this.$message.success('刷新令牌成功')
          // 更新令牌信息
          this.tokenStatus = {
            access_token: res.data.access_token,
            refresh_token: res.data.refresh_token,
            expires_time: res.data.expires_time
          }
          this.tokenForm = { ...this.tokenStatus }
        } else {
          this.$message.error(res.message || '刷新令牌失败')
        }
      } catch (error) {
        this.$message.error('刷新令牌失败：' + error.message)
      } finally {
        this.refreshLoading = false
      }
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}

.flexContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.cardHeader {
  font-size: 16px;
  font-weight: bold;
}
</style>
